define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MDppSpeciesDomain = void 0;
    class MDppSpeciesDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MDppSpeciesDomain.NoneObserved, value: "None observed" },
                    { key: MDppSpeciesDomain.C1AcaciasNonIndigenousToAustraliaAcaciellaSppMariosousaSppSenegaliaSppOtherThanSAlbizoidesAcaciaSppOtherThanANiloticaAndAFarnesiana, value: "C1 - Acacias non-indigenous to Australia (Acaciella spp., Mariosousa spp., Senegalia spp. (other than S. albizoides), Acacia spp. (other than A. nilotica and A. farnesiana))" },
                    { key: MDppSpeciesDomain.C1AlligatorWeedAlternantheraPhiloxeroides, value: "C1 - Alligator weed (Alternanthera philoxeroides)" },
                    { key: MDppSpeciesDomain.C1AnchoredWaterHyacinthEichhorniaAzurea, value: "C1 - Anchored water hyacinth (Eichhornia azurea)" },
                    { key: MDppSpeciesDomain.C1BadharaBushGmelinaElliptica, value: "C1 - Badhara bush (Gmelina elliptica)" },
                    { key: MDppSpeciesDomain.C1BitouBushChrysanthemoidesMoniliferaSubspRotundata, value: "C1 - Bitou bush (Chrysanthemoides monilifera subsp. rotundata)" },
                    { key: MDppSpeciesDomain.C1BridalCreeperAsparagusAsparagoides, value: "C1 - Bridal creeper (Asparagus asparagoides)" },
                    { key: MDppSpeciesDomain.C1CandleberryMyrthMyricaFaya, value: "C1 - Candleberry myrth (Myrica faya)" },
                    { key: MDppSpeciesDomain.C1ChileanNeedleGrassNassellaNeesiana, value: "C1 - Chilean needle grass (Nassella neesiana)" },
                    { key: MDppSpeciesDomain.C1ChollaCactusCylindropuntiaSppAndHybridsOtherThanCFulgidaCImbricataAndCSpinosior, value: "C1 - Cholla cactus (Cylindropuntia spp. And hybrids, other than C. fulgida, C. imbricata and C. spinosior)" },
                    { key: MDppSpeciesDomain.C1ChristsThornZiziphusSpinaChristi, value: "C1 - Christ's thorn (Ziziphus spina-christi)" },
                    { key: MDppSpeciesDomain.C1EurasianWaterMilfoilMyriophyllumSpicatum, value: "C1 - Eurasian water milfoil (Myriophyllum spicatum)" },
                    { key: MDppSpeciesDomain.C1FanwortCabombaSpp, value: "C1 - Fanwort (Cabomba spp.)" },
                    { key: MDppSpeciesDomain.C1FloatingWaterChestnutsTrapaSpp, value: "C1 - Floating water chestnuts (Trapa spp.)" },
                    { key: MDppSpeciesDomain.C1GorseUlexEuropaeus, value: "C1 - Gorse (Ulex europaeus)" },
                    { key: MDppSpeciesDomain.C1HarrisiaCactusHarrisiaSppSynEriocereusSppOtherThanHMartiniiHTortuosaAndHPomanensis, value: "C1 - Harrisia cactus (Harrisia spp. (syn. Eriocereus spp.) other than H. martinii, H. tortuosa and H. pomanensis)" },
                    { key: MDppSpeciesDomain.C1HoneyLocustGleditsiaSppIncludingCultivarsAndVarieties, value: "C1 - Honey locust (Gleditsia spp. including cultivars and varieties)" },
                    { key: MDppSpeciesDomain.C1HorsetailsEquisetumSpp, value: "C1 - Horsetails (Equisetum spp.)" },
                    { key: MDppSpeciesDomain.C1HygrophilaHygrophilaCostata, value: "C1 - Hygrophila (Hygrophila costata)" },
                    { key: MDppSpeciesDomain.C1KostersCurseClidemiaHirta, value: "C1 - Koster’s curse (Clidemia hirta)" },
                    { key: MDppSpeciesDomain.C1LagarosiphonLagarosiphonMajor, value: "C1 - Lagarosiphon (Lagarosiphon major)" },
                    { key: MDppSpeciesDomain.C1LimnocharisOrYellowBurrheadLimnocharisFlava, value: "C1 - Limnocharis or yellow burrhead (Limnocharis flava)" },
                    { key: MDppSpeciesDomain.C1MadrasThornPithecellobiumDulce, value: "C1 - Madras thorn (Pithecellobium dulce)" },
                    { key: MDppSpeciesDomain.C1MexicanBeanTreeCecropiaSpp, value: "C1 - Mexican bean tree (Cecropia spp.)" },
                    { key: MDppSpeciesDomain.C1MexicanFeatherGrassNassellaTenuissima, value: "C1 - Mexican feather grass (Nassella tenuissima)" },
                    { key: MDppSpeciesDomain.C1MiconiaMiconiaSpp, value: "C1 - Miconia (Miconia spp.)" },
                    { key: MDppSpeciesDomain.C1MikaniaVineMikaniaSpp, value: "C1 - Mikania vine (Mikania spp.)" },
                    { key: MDppSpeciesDomain.C1MimosaPigraMimosaPigra, value: "C1 - Mimosa pigra (Mimosa pigra)" },
                    { key: MDppSpeciesDomain.C1PeruvianPrimroseBushLugwigiaPeruviana, value: "C1 - Peruvian primrose bush (Lugwigia peruviana)" },
                    { key: MDppSpeciesDomain.C1PricklyPearOpuntiaSppOtherThanOFicusindicaOStrictaOAurantiacaOMonocanthaOTomentosaAndOStreptacantha, value: "C1 - Prickly pear (Opuntia spp. other than O. ficusindica, O. stricta, O. aurantiaca, O. monocantha, O. tomentosa and O. streptacantha)" },
                    { key: MDppSpeciesDomain.C1RedSesbaniaSesbaniaPunicea, value: "C1 - Red sesbania (Sesbania punicea)" },
                    { key: MDppSpeciesDomain.C1SalviniasSalviniaSpp, value: "C1 - Salvinias (Salvinia spp.)" },
                    { key: MDppSpeciesDomain.C1SenegalTeaGymnocoronisSpilanthoides, value: "C1 - Senegal tea (Gymnocoronis spilanthoides)" },
                    { key: MDppSpeciesDomain.C1SiamWeedChromolaenaSpp, value: "C1 - Siam weed (Chromolaena spp.)" },
                    { key: MDppSpeciesDomain.C1SpikedPepperPiperAduncum, value: "C1 - Spiked pepper (Piper aduncum)" },
                    { key: MDppSpeciesDomain.C1ThunbergiasAnnualThunbergiaThunbergiaAnnua, value: "C1 - Thunbergias: annual thunbergia (Thunbergia annua)" },
                    { key: MDppSpeciesDomain.C1ThunbergiasFragrantThunbergiaThunbergiaFragrans, value: "C1 - Thunbergias: fragrant thunbergia (Thunbergia fragrans)" },
                    { key: MDppSpeciesDomain.C1ThunbergiasLauralClockvineThunbergiaLaurifolia, value: "C1 - Thunbergias: laural clockvine (Thunbergia laurifolia)" },
                    { key: MDppSpeciesDomain.C1WaterMimosa1Of2NeptuniaOleracea, value: "C1 - Water mimosa 1 of 2 (Neptunia oleracea)" },
                    { key: MDppSpeciesDomain.C1WaterMimosa1Of2NeptuniaPlena, value: "C1 - Water mimosa 1 of 2 (Neptunia plena)" },
                    { key: MDppSpeciesDomain.C1WaterSoldiersStratiotesAloides, value: "C1 - Water soldiers (Stratiotes aloides)" },
                    { key: MDppSpeciesDomain.C1WillowSalixSppOtherThanSBabylonicaSHumboldtianaSMatsudanaSXCalodendronAndSXReichardtii, value: "C1 - Willow (Salix spp. Other than S. babylonica, S. humboldtiana, S. matsudana, S x calodendron and S. x reichardtii)" },
                    { key: MDppSpeciesDomain.C1WitchWeedsStrigaSppOtherThanNativeSpecies, value: "C1 - Witch weeds (Striga spp. Other than native species)" },
                    { key: MDppSpeciesDomain.C1YellowGingerHedychiumFlavescens, value: "C1 - Yellow ginger (Hedychium flavescens)" },
                    { key: MDppSpeciesDomain.C2AfricanBoxthornLyciumFerocissimum, value: "C2 - African boxthorn (Lycium ferocissimum)" },
                    { key: MDppSpeciesDomain.C2AnnualRagweedAmbrosiaArtemisiifolia, value: "C2 - Annual ragweed (Ambrosia artemisiifolia)" },
                    { key: MDppSpeciesDomain.C2BellyAcheBushJatrophaGossypiifoliaAndHybrids, value: "C2 - Belly-ache bush (Jatropha gossypiifolia and hybrids)" },
                    { key: MDppSpeciesDomain.C2CabombaCabombaCaroliniana, value: "C2 - Cabomba (Cabomba caroliniana)" },
                    { key: MDppSpeciesDomain.C2ChineseAppleZiziphusMauritiana, value: "C2 - Chinese apple (Ziziphus mauritiana)" },
                    { key: MDppSpeciesDomain.C2ChollaCactiCoralCactusCylindropuntiaFulgida, value: "C2 - Cholla cacti: coral cactus (Cylindropuntia fulgida)" },
                    { key: MDppSpeciesDomain.C2ChollaCactiDevilsRopePearCylindropuntiaImbricata, value: "C2 - Cholla cacti: devil’s rope pear (Cylindropuntia imbricata)" },
                    { key: MDppSpeciesDomain.C2ChollaCactiSnakeCactusCylindropuntiaSpinosior, value: "C2 - Cholla cacti: snake cactus (Cylindropuntia spinosior)" },
                    { key: MDppSpeciesDomain.C2FireweedSenecioMadagascariensis, value: "C2 - Fireweed (Senecio madagascariensis)" },
                    { key: MDppSpeciesDomain.C2GambaGrassAndropogonGayanus, value: "C2 - Gamba grass (Andropogon gayanus)" },
                    { key: MDppSpeciesDomain.C2GiantSensitivePlantMimosaDiplotrichaVarDiplotricha, value: "C2 - Giant sensitive plant (Mimosa diplotricha var. diplotricha)" },
                    { key: MDppSpeciesDomain.C2GroundselBushBaccharisHalimifolia, value: "C2 - Groundsel bush (Baccharis halimifolia)" },
                    { key: MDppSpeciesDomain.C2HarrisiaCactus1Of3HarrisiaMartiniiSynEriocereusMartinii, value: "C2 - Harrisia cactus 1 of 3 (Harrisia martinii (syn. Eriocereus martinii))" },
                    { key: MDppSpeciesDomain.C2HarrisiaCactus2Of3HarrisiaTortuosa, value: "C2 - Harrisia cactus 2 of 3 (Harrisia tortuosa)" },
                    { key: MDppSpeciesDomain.C2HarrisiaCactus3Of3HarrisiaPomanensisSynCereusPomanensis, value: "C2 - Harrisia cactus 3 of 3 (Harrisia pomanensis (syn. Cereus pomanensis))" },
                    { key: MDppSpeciesDomain.C2HymenachneOrOliveHymenachneHymenachneAmplexicaulis, value: "C2 - Hymenachne or Olive hymenachne (Hymenachne amplexicaulis)" },
                    { key: MDppSpeciesDomain.C2KudzuPuerariaMontanaVarLobataSynPuerariaLobata, value: "C2 - Kudzu (Pueraria montana var. lobata (syn. Pueraria lobata))" },
                    { key: MDppSpeciesDomain.C2Mesquite1Of3ProsopisGlandulosa, value: "C2 - Mesquite 1 of 3 (Prosopis glandulosa)" },
                    { key: MDppSpeciesDomain.C2Mesquite2Of3ProsopisPallida, value: "C2 - Mesquite 2 of 3 (Prosopis pallida)" },
                    { key: MDppSpeciesDomain.C2Mesquite3Of3ProsopisVelutina, value: "C2 - Mesquite 3 of 3 (Prosopis velutina)" },
                    { key: MDppSpeciesDomain.C2MotherOfMillions1Of2BryophyllumDelagoenseSynBTubiflorum, value: "C2 - Mother of millions 1 of 2 (Bryophyllum delagoense (syn. B. tubiflorum))" },
                    { key: MDppSpeciesDomain.C2MotherOfMillions2Of2KalanchoeDelagoensis, value: "C2 - Mother of millions 2 of 2 (Kalanchoe delagoensis)" },
                    { key: MDppSpeciesDomain.C2MotherOfMillionsHybridBryophyllumXHoughtoniiSynBDaigremontianumXBDelagoenseKalanchoeXHoughtonii, value: "C2 - Mother of millions hybrid (Bryophyllum x houghtonii (syn. B.daigremontianum x B. delagoense, Kalanchoe x houghtonii))" },
                    { key: MDppSpeciesDomain.C2ParkinsoniaParkinsoniaAculeata, value: "C2 - Parkinsonia (Parkinsonia aculeata)" },
                    { key: MDppSpeciesDomain.C2PartheniumPartheniumHysterophorus, value: "C2 - Parthenium (Parthenium hysterophorus)" },
                    { key: MDppSpeciesDomain.C2PondAppleAnnonaGlabra, value: "C2 - Pond apple (Annona glabra)" },
                    { key: MDppSpeciesDomain.C2PricklyAcaciaAcaciaNilotica, value: "C2 - Prickly acacia (Acacia nilotica)" },
                    { key: MDppSpeciesDomain.C2PricklyPearsCommonPestPearOrSpinyPestPearOpuntiaStrictaSynOInermis, value: "C2 - Prickly pears: common pest pear or spiny pest pear (Opuntia stricta (syn. O. inermis))" },
                    { key: MDppSpeciesDomain.C2PricklyPearsDroopingTreePearOpuntiaMonacanthaSynOVulgaris, value: "C2 - Prickly pears: drooping tree pear (Opuntia monacantha (syn. O. vulgaris))" },
                    { key: MDppSpeciesDomain.C2PricklyPearsSpinyPestPearOrCommonPestPearOpuntiaStrictaSynOInermis, value: "C2 - Prickly pears: spiny pest pear or common pest pear (Opuntia stricta (syn. O. inermis))" },
                    { key: MDppSpeciesDomain.C2PricklyPearsTigerPearOpuntiaAurantiaca, value: "C2 - Prickly pears: tiger pear (Opuntia aurantiaca)" },
                    { key: MDppSpeciesDomain.C2PricklyPearsVelvetyTreePearOpuntiaTomentosa, value: "C2 - Prickly pears: velvety tree pear (Opuntia tomentosa)" },
                    { key: MDppSpeciesDomain.C2PricklyPearsWestwoodPearOpuntiaStreptacantha, value: "C2 - Prickly pears: Westwood pear (Opuntia streptacantha)" },
                    { key: MDppSpeciesDomain.C2RatsTailGrassesAmericanRatsTailGrassSporobolusJacquemontii, value: "C2 - Rat's tail grasses: American rat's tail grass (Sporobolus jacquemontii)" },
                    { key: MDppSpeciesDomain.C2RatsTailGrassesGiantParramattaGrassSporobolusFertilis, value: "C2 - Rat's tail grasses: giant Parramatta grass (Sporobolus fertilis)" },
                    { key: MDppSpeciesDomain.C2RatsTailGrassesGiantRatsTailGrass1SporobolusPyramidalis, value: "C2 - Rat's tail grasses: giant rat's tail grass 1 (Sporobolus pyramidalis)" },
                    { key: MDppSpeciesDomain.C2RatsTailGrassesGiantRatsTailGrass2SporobolusNatalensis, value: "C2 - Rat's tail grasses: giant rat's tail grass 2 (Sporobolus natalensis)" },
                    { key: MDppSpeciesDomain.C2RatsTailGrassesParramattaGrassSporobolusAfricanus, value: "C2 - Rat's tail grasses: Parramatta grass (Sporobolus africanus)" },
                    { key: MDppSpeciesDomain.C2RubberVineCryptostegiaGrandiflora, value: "C2 - Rubber vine (Cryptostegia grandiflora)" },
                    { key: MDppSpeciesDomain.C2SalviniaSalviniaMolesta, value: "C2 - Salvinia (Salvinia molesta)" },
                    { key: MDppSpeciesDomain.C2SicklepodsFoetidCassiaSennaTora, value: "C2 - Sicklepods: foetid cassia (Senna tora)" },
                    { key: MDppSpeciesDomain.C2SicklepodsHairyCassiaSennaHirsuta, value: "C2 - Sicklepods: hairy cassia (Senna hirsuta)" },
                    { key: MDppSpeciesDomain.C2SicklepodsSicklepodSennaObtusifolia, value: "C2 - Sicklepods: sicklepod (Senna obtusifolia)" },
                    { key: MDppSpeciesDomain.C2TelegraphWeedHeterothecaGrandiflora, value: "C2 - Telegraph weed (Heterotheca grandiflora)" },
                    { key: MDppSpeciesDomain.C2ThunbergiaOrBlueThunbergiaThunbergiaGrandiflora, value: "C2 - Thunbergia or blue thunbergia (Thunbergia grandiflora)" },
                    { key: MDppSpeciesDomain.C2TobaccoWeedElephantopusMollis, value: "C2 - Tobacco weed (Elephantopus mollis)" },
                    { key: MDppSpeciesDomain.C2WaterHyacinthEichhorniaCrassipes, value: "C2 - Water hyacinth (Eichhornia crassipes)" },
                    { key: MDppSpeciesDomain.C2WaterLettucePistiaStratiotes, value: "C2 - Water lettuce (Pistia stratiotes)" },
                    { key: MDppSpeciesDomain.C3AfricanFountainGrassPennisetumSetaceum, value: "C3 - African fountain grass (Pennisetum setaceum)" },
                    { key: MDppSpeciesDomain.C3AfricanTulipTreeSpathodeaCampanulata, value: "C3 - African tulip tree (Spathodea campanulata)" },
                    { key: MDppSpeciesDomain.C3AsparagusFernGroundAsparagusAsparagusAethiopicusSprengeri, value: "C3 - Asparagus fern: Ground asparagus (Asparagus aethiopicus Sprengeri)" },
                    { key: MDppSpeciesDomain.C3AsparagusFernClimbingAsparagusAsparagusAfricanus, value: "C3 - Asparagus fern: Climbing asparagus (Asparagus africanus)" },
                    { key: MDppSpeciesDomain.C3AsparagusFernFeatheredAsparagusFernAsparagusPlumosus, value: "C3 - Asparagus fern: feathered asparagus fern (Asparagus plumosus)" },
                    { key: MDppSpeciesDomain.C3AthelPineTamarixAphylla, value: "C3 - Athel pine (Tamarix aphylla)" },
                    { key: MDppSpeciesDomain.C3BalloonVineCardiospermumGrandiflorum, value: "C3 - Balloon vine (Cardiospermum grandiflorum)" },
                    { key: MDppSpeciesDomain.C3Blackberry1RubusAnglocandicans, value: "C3 - Blackberry 1 (Rubus anglocandicans)" },
                    { key: MDppSpeciesDomain.C3Blackberry2RubusFruticosusAgg, value: "C3 - Blackberry 2 (Rubus fruticosus agg.)" },
                    { key: MDppSpeciesDomain.C3BroadLeavedPepperTreeSchinusTerebinthifolius, value: "C3 - Broad-leaved pepper tree (Schinus terebinthifolius)" },
                    { key: MDppSpeciesDomain.C3CamphorLaurelCinnamomumCamphora, value: "C3 - Camphor laurel (Cinnamomum camphora)" },
                    { key: MDppSpeciesDomain.C3CaptainCookTreeOrYellowOleanderCascabelaThevetiaSynThevetiaPeruviana, value: "C3 - Captain Cook tree or yellow oleander (Cascabela thevetia (syn. Thevetia peruviana))" },
                    { key: MDppSpeciesDomain.C3CatsClawCreeperMacfadyenaUnguisCati, value: "C3 - Cat's claw creeper (Macfadyena unguis-cati)" },
                    { key: MDppSpeciesDomain.C3ChineseCeltisCeltisSinensis, value: "C3 - Chinese celtis (Celtis sinensis)" },
                    { key: MDppSpeciesDomain.C3DutchmansPipeOrAristolochiaAristolochiaSppOtherThanNativeSpecies, value: "C3 - Dutchman's pipe or aristolochia (Aristolochia spp. other than native species)" },
                    { key: MDppSpeciesDomain.C3HarunganaHarunganaMadagascariensis, value: "C3 - Harungana (Harungana madagascariensis)" },
                    { key: MDppSpeciesDomain.C3KahiliGingerHedychiumGardnerianum, value: "C3 - Kahili ginger (Hedychium gardnerianum)" },
                    { key: MDppSpeciesDomain.C3LantanasCommonLantanaOrLantanaLantanaCamara, value: "C3 - Lantanas: common lantana or lantana (Lantana camara)" },
                    { key: MDppSpeciesDomain.C3LantanasCreepingLantanaLantanaMontevidensis, value: "C3 - Lantanas: creeping lantana (Lantana montevidensis)" },
                    { key: MDppSpeciesDomain.C3MadeiraVineAnrederaCordifolia, value: "C3 - Madeira vine (Anredera cordifolia)" },
                    { key: MDppSpeciesDomain.C3OrnamentalRubberVineCryptostegiaMadagascariensis, value: "C3 - Ornamental rubber vine (Cryptostegia madagascariensis)" },
                    { key: MDppSpeciesDomain.C3PrivetsBroadLeafPrivetOrTreePrivetLigustrumLucidum, value: "C3 - Privets: broad-leaf privet or tree privet (Ligustrum lucidum)" },
                    { key: MDppSpeciesDomain.C3PrivetsChinesePrivetOrSmallLeafPrivetLigustrumSinense, value: "C3 - Privets: Chinese privet or small-leaf privet (Ligustrum sinense)" },
                    { key: MDppSpeciesDomain.C3PrivetsSmallLeafPrivetOrChinesePrivetLigustrumSinense, value: "C3 - Privets: small-leaf privet or Chinese privet (Ligustrum sinense)" },
                    { key: MDppSpeciesDomain.C3SingaporeDaisySphagneticolaTrilobataSynWedeliaTrilobata, value: "C3 - Singapore daisy (Sphagneticola trilobata (syn. Wedelia trilobata))" },
                    { key: MDppSpeciesDomain.C3WhiteGingerHedychiumCoronarium, value: "C3 - White ginger (Hedychium coronarium)" },
                    { key: MDppSpeciesDomain.C3WillowsPencilWillowSalixHumboldtianaSynSChilensis, value: "C3 - Willows: pencil willow (Salix humboldtiana (syn. S. chilensis))" },
                    { key: MDppSpeciesDomain.C3WillowsTorturedWillowSalixMatsudana, value: "C3 - Willows: tortured willow (Salix matsudana)" },
                    { key: MDppSpeciesDomain.C3YellowBellsTecomaStans, value: "C3 - Yellow bells (Tecoma stans)" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MDppSpeciesDomain.NoneObserved] = 0;
                this.KeyIndex[MDppSpeciesDomain.C1AcaciasNonIndigenousToAustraliaAcaciellaSppMariosousaSppSenegaliaSppOtherThanSAlbizoidesAcaciaSppOtherThanANiloticaAndAFarnesiana] = 1;
                this.KeyIndex[MDppSpeciesDomain.C1AlligatorWeedAlternantheraPhiloxeroides] = 2;
                this.KeyIndex[MDppSpeciesDomain.C1AnchoredWaterHyacinthEichhorniaAzurea] = 3;
                this.KeyIndex[MDppSpeciesDomain.C1BadharaBushGmelinaElliptica] = 4;
                this.KeyIndex[MDppSpeciesDomain.C1BitouBushChrysanthemoidesMoniliferaSubspRotundata] = 5;
                this.KeyIndex[MDppSpeciesDomain.C1BridalCreeperAsparagusAsparagoides] = 6;
                this.KeyIndex[MDppSpeciesDomain.C1CandleberryMyrthMyricaFaya] = 7;
                this.KeyIndex[MDppSpeciesDomain.C1ChileanNeedleGrassNassellaNeesiana] = 8;
                this.KeyIndex[MDppSpeciesDomain.C1ChollaCactusCylindropuntiaSppAndHybridsOtherThanCFulgidaCImbricataAndCSpinosior] = 9;
                this.KeyIndex[MDppSpeciesDomain.C1ChristsThornZiziphusSpinaChristi] = 10;
                this.KeyIndex[MDppSpeciesDomain.C1EurasianWaterMilfoilMyriophyllumSpicatum] = 11;
                this.KeyIndex[MDppSpeciesDomain.C1FanwortCabombaSpp] = 12;
                this.KeyIndex[MDppSpeciesDomain.C1FloatingWaterChestnutsTrapaSpp] = 13;
                this.KeyIndex[MDppSpeciesDomain.C1GorseUlexEuropaeus] = 14;
                this.KeyIndex[MDppSpeciesDomain.C1HarrisiaCactusHarrisiaSppSynEriocereusSppOtherThanHMartiniiHTortuosaAndHPomanensis] = 15;
                this.KeyIndex[MDppSpeciesDomain.C1HoneyLocustGleditsiaSppIncludingCultivarsAndVarieties] = 16;
                this.KeyIndex[MDppSpeciesDomain.C1HorsetailsEquisetumSpp] = 17;
                this.KeyIndex[MDppSpeciesDomain.C1HygrophilaHygrophilaCostata] = 18;
                this.KeyIndex[MDppSpeciesDomain.C1KostersCurseClidemiaHirta] = 19;
                this.KeyIndex[MDppSpeciesDomain.C1LagarosiphonLagarosiphonMajor] = 20;
                this.KeyIndex[MDppSpeciesDomain.C1LimnocharisOrYellowBurrheadLimnocharisFlava] = 21;
                this.KeyIndex[MDppSpeciesDomain.C1MadrasThornPithecellobiumDulce] = 22;
                this.KeyIndex[MDppSpeciesDomain.C1MexicanBeanTreeCecropiaSpp] = 23;
                this.KeyIndex[MDppSpeciesDomain.C1MexicanFeatherGrassNassellaTenuissima] = 24;
                this.KeyIndex[MDppSpeciesDomain.C1MiconiaMiconiaSpp] = 25;
                this.KeyIndex[MDppSpeciesDomain.C1MikaniaVineMikaniaSpp] = 26;
                this.KeyIndex[MDppSpeciesDomain.C1MimosaPigraMimosaPigra] = 27;
                this.KeyIndex[MDppSpeciesDomain.C1PeruvianPrimroseBushLugwigiaPeruviana] = 28;
                this.KeyIndex[MDppSpeciesDomain.C1PricklyPearOpuntiaSppOtherThanOFicusindicaOStrictaOAurantiacaOMonocanthaOTomentosaAndOStreptacantha] = 29;
                this.KeyIndex[MDppSpeciesDomain.C1RedSesbaniaSesbaniaPunicea] = 30;
                this.KeyIndex[MDppSpeciesDomain.C1SalviniasSalviniaSpp] = 31;
                this.KeyIndex[MDppSpeciesDomain.C1SenegalTeaGymnocoronisSpilanthoides] = 32;
                this.KeyIndex[MDppSpeciesDomain.C1SiamWeedChromolaenaSpp] = 33;
                this.KeyIndex[MDppSpeciesDomain.C1SpikedPepperPiperAduncum] = 34;
                this.KeyIndex[MDppSpeciesDomain.C1ThunbergiasAnnualThunbergiaThunbergiaAnnua] = 35;
                this.KeyIndex[MDppSpeciesDomain.C1ThunbergiasFragrantThunbergiaThunbergiaFragrans] = 36;
                this.KeyIndex[MDppSpeciesDomain.C1ThunbergiasLauralClockvineThunbergiaLaurifolia] = 37;
                this.KeyIndex[MDppSpeciesDomain.C1WaterMimosa1Of2NeptuniaOleracea] = 38;
                this.KeyIndex[MDppSpeciesDomain.C1WaterMimosa1Of2NeptuniaPlena] = 39;
                this.KeyIndex[MDppSpeciesDomain.C1WaterSoldiersStratiotesAloides] = 40;
                this.KeyIndex[MDppSpeciesDomain.C1WillowSalixSppOtherThanSBabylonicaSHumboldtianaSMatsudanaSXCalodendronAndSXReichardtii] = 41;
                this.KeyIndex[MDppSpeciesDomain.C1WitchWeedsStrigaSppOtherThanNativeSpecies] = 42;
                this.KeyIndex[MDppSpeciesDomain.C1YellowGingerHedychiumFlavescens] = 43;
                this.KeyIndex[MDppSpeciesDomain.C2AfricanBoxthornLyciumFerocissimum] = 44;
                this.KeyIndex[MDppSpeciesDomain.C2AnnualRagweedAmbrosiaArtemisiifolia] = 45;
                this.KeyIndex[MDppSpeciesDomain.C2BellyAcheBushJatrophaGossypiifoliaAndHybrids] = 46;
                this.KeyIndex[MDppSpeciesDomain.C2CabombaCabombaCaroliniana] = 47;
                this.KeyIndex[MDppSpeciesDomain.C2ChineseAppleZiziphusMauritiana] = 48;
                this.KeyIndex[MDppSpeciesDomain.C2ChollaCactiCoralCactusCylindropuntiaFulgida] = 49;
                this.KeyIndex[MDppSpeciesDomain.C2ChollaCactiDevilsRopePearCylindropuntiaImbricata] = 50;
                this.KeyIndex[MDppSpeciesDomain.C2ChollaCactiSnakeCactusCylindropuntiaSpinosior] = 51;
                this.KeyIndex[MDppSpeciesDomain.C2FireweedSenecioMadagascariensis] = 52;
                this.KeyIndex[MDppSpeciesDomain.C2GambaGrassAndropogonGayanus] = 53;
                this.KeyIndex[MDppSpeciesDomain.C2GiantSensitivePlantMimosaDiplotrichaVarDiplotricha] = 54;
                this.KeyIndex[MDppSpeciesDomain.C2GroundselBushBaccharisHalimifolia] = 55;
                this.KeyIndex[MDppSpeciesDomain.C2HarrisiaCactus1Of3HarrisiaMartiniiSynEriocereusMartinii] = 56;
                this.KeyIndex[MDppSpeciesDomain.C2HarrisiaCactus2Of3HarrisiaTortuosa] = 57;
                this.KeyIndex[MDppSpeciesDomain.C2HarrisiaCactus3Of3HarrisiaPomanensisSynCereusPomanensis] = 58;
                this.KeyIndex[MDppSpeciesDomain.C2HymenachneOrOliveHymenachneHymenachneAmplexicaulis] = 59;
                this.KeyIndex[MDppSpeciesDomain.C2KudzuPuerariaMontanaVarLobataSynPuerariaLobata] = 60;
                this.KeyIndex[MDppSpeciesDomain.C2Mesquite1Of3ProsopisGlandulosa] = 61;
                this.KeyIndex[MDppSpeciesDomain.C2Mesquite2Of3ProsopisPallida] = 62;
                this.KeyIndex[MDppSpeciesDomain.C2Mesquite3Of3ProsopisVelutina] = 63;
                this.KeyIndex[MDppSpeciesDomain.C2MotherOfMillions1Of2BryophyllumDelagoenseSynBTubiflorum] = 64;
                this.KeyIndex[MDppSpeciesDomain.C2MotherOfMillions2Of2KalanchoeDelagoensis] = 65;
                this.KeyIndex[MDppSpeciesDomain.C2MotherOfMillionsHybridBryophyllumXHoughtoniiSynBDaigremontianumXBDelagoenseKalanchoeXHoughtonii] = 66;
                this.KeyIndex[MDppSpeciesDomain.C2ParkinsoniaParkinsoniaAculeata] = 67;
                this.KeyIndex[MDppSpeciesDomain.C2PartheniumPartheniumHysterophorus] = 68;
                this.KeyIndex[MDppSpeciesDomain.C2PondAppleAnnonaGlabra] = 69;
                this.KeyIndex[MDppSpeciesDomain.C2PricklyAcaciaAcaciaNilotica] = 70;
                this.KeyIndex[MDppSpeciesDomain.C2PricklyPearsCommonPestPearOrSpinyPestPearOpuntiaStrictaSynOInermis] = 71;
                this.KeyIndex[MDppSpeciesDomain.C2PricklyPearsDroopingTreePearOpuntiaMonacanthaSynOVulgaris] = 72;
                this.KeyIndex[MDppSpeciesDomain.C2PricklyPearsSpinyPestPearOrCommonPestPearOpuntiaStrictaSynOInermis] = 73;
                this.KeyIndex[MDppSpeciesDomain.C2PricklyPearsTigerPearOpuntiaAurantiaca] = 74;
                this.KeyIndex[MDppSpeciesDomain.C2PricklyPearsVelvetyTreePearOpuntiaTomentosa] = 75;
                this.KeyIndex[MDppSpeciesDomain.C2PricklyPearsWestwoodPearOpuntiaStreptacantha] = 76;
                this.KeyIndex[MDppSpeciesDomain.C2RatsTailGrassesAmericanRatsTailGrassSporobolusJacquemontii] = 77;
                this.KeyIndex[MDppSpeciesDomain.C2RatsTailGrassesGiantParramattaGrassSporobolusFertilis] = 78;
                this.KeyIndex[MDppSpeciesDomain.C2RatsTailGrassesGiantRatsTailGrass1SporobolusPyramidalis] = 79;
                this.KeyIndex[MDppSpeciesDomain.C2RatsTailGrassesGiantRatsTailGrass2SporobolusNatalensis] = 80;
                this.KeyIndex[MDppSpeciesDomain.C2RatsTailGrassesParramattaGrassSporobolusAfricanus] = 81;
                this.KeyIndex[MDppSpeciesDomain.C2RubberVineCryptostegiaGrandiflora] = 82;
                this.KeyIndex[MDppSpeciesDomain.C2SalviniaSalviniaMolesta] = 83;
                this.KeyIndex[MDppSpeciesDomain.C2SicklepodsFoetidCassiaSennaTora] = 84;
                this.KeyIndex[MDppSpeciesDomain.C2SicklepodsHairyCassiaSennaHirsuta] = 85;
                this.KeyIndex[MDppSpeciesDomain.C2SicklepodsSicklepodSennaObtusifolia] = 86;
                this.KeyIndex[MDppSpeciesDomain.C2TelegraphWeedHeterothecaGrandiflora] = 87;
                this.KeyIndex[MDppSpeciesDomain.C2ThunbergiaOrBlueThunbergiaThunbergiaGrandiflora] = 88;
                this.KeyIndex[MDppSpeciesDomain.C2TobaccoWeedElephantopusMollis] = 89;
                this.KeyIndex[MDppSpeciesDomain.C2WaterHyacinthEichhorniaCrassipes] = 90;
                this.KeyIndex[MDppSpeciesDomain.C2WaterLettucePistiaStratiotes] = 91;
                this.KeyIndex[MDppSpeciesDomain.C3AfricanFountainGrassPennisetumSetaceum] = 92;
                this.KeyIndex[MDppSpeciesDomain.C3AfricanTulipTreeSpathodeaCampanulata] = 93;
                this.KeyIndex[MDppSpeciesDomain.C3AsparagusFernGroundAsparagusAsparagusAethiopicusSprengeri] = 94;
                this.KeyIndex[MDppSpeciesDomain.C3AsparagusFernClimbingAsparagusAsparagusAfricanus] = 95;
                this.KeyIndex[MDppSpeciesDomain.C3AsparagusFernFeatheredAsparagusFernAsparagusPlumosus] = 96;
                this.KeyIndex[MDppSpeciesDomain.C3AthelPineTamarixAphylla] = 97;
                this.KeyIndex[MDppSpeciesDomain.C3BalloonVineCardiospermumGrandiflorum] = 98;
                this.KeyIndex[MDppSpeciesDomain.C3Blackberry1RubusAnglocandicans] = 99;
                this.KeyIndex[MDppSpeciesDomain.C3Blackberry2RubusFruticosusAgg] = 100;
                this.KeyIndex[MDppSpeciesDomain.C3BroadLeavedPepperTreeSchinusTerebinthifolius] = 101;
                this.KeyIndex[MDppSpeciesDomain.C3CamphorLaurelCinnamomumCamphora] = 102;
                this.KeyIndex[MDppSpeciesDomain.C3CaptainCookTreeOrYellowOleanderCascabelaThevetiaSynThevetiaPeruviana] = 103;
                this.KeyIndex[MDppSpeciesDomain.C3CatsClawCreeperMacfadyenaUnguisCati] = 104;
                this.KeyIndex[MDppSpeciesDomain.C3ChineseCeltisCeltisSinensis] = 105;
                this.KeyIndex[MDppSpeciesDomain.C3DutchmansPipeOrAristolochiaAristolochiaSppOtherThanNativeSpecies] = 106;
                this.KeyIndex[MDppSpeciesDomain.C3HarunganaHarunganaMadagascariensis] = 107;
                this.KeyIndex[MDppSpeciesDomain.C3KahiliGingerHedychiumGardnerianum] = 108;
                this.KeyIndex[MDppSpeciesDomain.C3LantanasCommonLantanaOrLantanaLantanaCamara] = 109;
                this.KeyIndex[MDppSpeciesDomain.C3LantanasCreepingLantanaLantanaMontevidensis] = 110;
                this.KeyIndex[MDppSpeciesDomain.C3MadeiraVineAnrederaCordifolia] = 111;
                this.KeyIndex[MDppSpeciesDomain.C3OrnamentalRubberVineCryptostegiaMadagascariensis] = 112;
                this.KeyIndex[MDppSpeciesDomain.C3PrivetsBroadLeafPrivetOrTreePrivetLigustrumLucidum] = 113;
                this.KeyIndex[MDppSpeciesDomain.C3PrivetsChinesePrivetOrSmallLeafPrivetLigustrumSinense] = 114;
                this.KeyIndex[MDppSpeciesDomain.C3PrivetsSmallLeafPrivetOrChinesePrivetLigustrumSinense] = 115;
                this.KeyIndex[MDppSpeciesDomain.C3SingaporeDaisySphagneticolaTrilobataSynWedeliaTrilobata] = 116;
                this.KeyIndex[MDppSpeciesDomain.C3WhiteGingerHedychiumCoronarium] = 117;
                this.KeyIndex[MDppSpeciesDomain.C3WillowsPencilWillowSalixHumboldtianaSynSChilensis] = 118;
                this.KeyIndex[MDppSpeciesDomain.C3WillowsTorturedWillowSalixMatsudana] = 119;
                this.KeyIndex[MDppSpeciesDomain.C3YellowBellsTecomaStans] = 120;
                this.ValueIndex = {};
                this.ValueIndex["None observed"] = 0;
                this.ValueIndex["C1 - Acacias non-indigenous to Australia (Acaciella spp., Mariosousa spp., Senegalia spp. (other than S. albizoides), Acacia spp. (other than A. nilotica and A. farnesiana))"] = 1;
                this.ValueIndex["C1 - Alligator weed (Alternanthera philoxeroides)"] = 2;
                this.ValueIndex["C1 - Anchored water hyacinth (Eichhornia azurea)"] = 3;
                this.ValueIndex["C1 - Badhara bush (Gmelina elliptica)"] = 4;
                this.ValueIndex["C1 - Bitou bush (Chrysanthemoides monilifera subsp. rotundata)"] = 5;
                this.ValueIndex["C1 - Bridal creeper (Asparagus asparagoides)"] = 6;
                this.ValueIndex["C1 - Candleberry myrth (Myrica faya)"] = 7;
                this.ValueIndex["C1 - Chilean needle grass (Nassella neesiana)"] = 8;
                this.ValueIndex["C1 - Cholla cactus (Cylindropuntia spp. And hybrids, other than C. fulgida, C. imbricata and C. spinosior)"] = 9;
                this.ValueIndex["C1 - Christ's thorn (Ziziphus spina-christi)"] = 10;
                this.ValueIndex["C1 - Eurasian water milfoil (Myriophyllum spicatum)"] = 11;
                this.ValueIndex["C1 - Fanwort (Cabomba spp.)"] = 12;
                this.ValueIndex["C1 - Floating water chestnuts (Trapa spp.)"] = 13;
                this.ValueIndex["C1 - Gorse (Ulex europaeus)"] = 14;
                this.ValueIndex["C1 - Harrisia cactus (Harrisia spp. (syn. Eriocereus spp.) other than H. martinii, H. tortuosa and H. pomanensis)"] = 15;
                this.ValueIndex["C1 - Honey locust (Gleditsia spp. including cultivars and varieties)"] = 16;
                this.ValueIndex["C1 - Horsetails (Equisetum spp.)"] = 17;
                this.ValueIndex["C1 - Hygrophila (Hygrophila costata)"] = 18;
                this.ValueIndex["C1 - Koster’s curse (Clidemia hirta)"] = 19;
                this.ValueIndex["C1 - Lagarosiphon (Lagarosiphon major)"] = 20;
                this.ValueIndex["C1 - Limnocharis or yellow burrhead (Limnocharis flava)"] = 21;
                this.ValueIndex["C1 - Madras thorn (Pithecellobium dulce)"] = 22;
                this.ValueIndex["C1 - Mexican bean tree (Cecropia spp.)"] = 23;
                this.ValueIndex["C1 - Mexican feather grass (Nassella tenuissima)"] = 24;
                this.ValueIndex["C1 - Miconia (Miconia spp.)"] = 25;
                this.ValueIndex["C1 - Mikania vine (Mikania spp.)"] = 26;
                this.ValueIndex["C1 - Mimosa pigra (Mimosa pigra)"] = 27;
                this.ValueIndex["C1 - Peruvian primrose bush (Lugwigia peruviana)"] = 28;
                this.ValueIndex["C1 - Prickly pear (Opuntia spp. other than O. ficusindica, O. stricta, O. aurantiaca, O. monocantha, O. tomentosa and O. streptacantha)"] = 29;
                this.ValueIndex["C1 - Red sesbania (Sesbania punicea)"] = 30;
                this.ValueIndex["C1 - Salvinias (Salvinia spp.)"] = 31;
                this.ValueIndex["C1 - Senegal tea (Gymnocoronis spilanthoides)"] = 32;
                this.ValueIndex["C1 - Siam weed (Chromolaena spp.)"] = 33;
                this.ValueIndex["C1 - Spiked pepper (Piper aduncum)"] = 34;
                this.ValueIndex["C1 - Thunbergias: annual thunbergia (Thunbergia annua)"] = 35;
                this.ValueIndex["C1 - Thunbergias: fragrant thunbergia (Thunbergia fragrans)"] = 36;
                this.ValueIndex["C1 - Thunbergias: laural clockvine (Thunbergia laurifolia)"] = 37;
                this.ValueIndex["C1 - Water mimosa 1 of 2 (Neptunia oleracea)"] = 38;
                this.ValueIndex["C1 - Water mimosa 1 of 2 (Neptunia plena)"] = 39;
                this.ValueIndex["C1 - Water soldiers (Stratiotes aloides)"] = 40;
                this.ValueIndex["C1 - Willow (Salix spp. Other than S. babylonica, S. humboldtiana, S. matsudana, S x calodendron and S. x reichardtii)"] = 41;
                this.ValueIndex["C1 - Witch weeds (Striga spp. Other than native species)"] = 42;
                this.ValueIndex["C1 - Yellow ginger (Hedychium flavescens)"] = 43;
                this.ValueIndex["C2 - African boxthorn (Lycium ferocissimum)"] = 44;
                this.ValueIndex["C2 - Annual ragweed (Ambrosia artemisiifolia)"] = 45;
                this.ValueIndex["C2 - Belly-ache bush (Jatropha gossypiifolia and hybrids)"] = 46;
                this.ValueIndex["C2 - Cabomba (Cabomba caroliniana)"] = 47;
                this.ValueIndex["C2 - Chinese apple (Ziziphus mauritiana)"] = 48;
                this.ValueIndex["C2 - Cholla cacti: coral cactus (Cylindropuntia fulgida)"] = 49;
                this.ValueIndex["C2 - Cholla cacti: devil’s rope pear (Cylindropuntia imbricata)"] = 50;
                this.ValueIndex["C2 - Cholla cacti: snake cactus (Cylindropuntia spinosior)"] = 51;
                this.ValueIndex["C2 - Fireweed (Senecio madagascariensis)"] = 52;
                this.ValueIndex["C2 - Gamba grass (Andropogon gayanus)"] = 53;
                this.ValueIndex["C2 - Giant sensitive plant (Mimosa diplotricha var. diplotricha)"] = 54;
                this.ValueIndex["C2 - Groundsel bush (Baccharis halimifolia)"] = 55;
                this.ValueIndex["C2 - Harrisia cactus 1 of 3 (Harrisia martinii (syn. Eriocereus martinii))"] = 56;
                this.ValueIndex["C2 - Harrisia cactus 2 of 3 (Harrisia tortuosa)"] = 57;
                this.ValueIndex["C2 - Harrisia cactus 3 of 3 (Harrisia pomanensis (syn. Cereus pomanensis))"] = 58;
                this.ValueIndex["C2 - Hymenachne or Olive hymenachne (Hymenachne amplexicaulis)"] = 59;
                this.ValueIndex["C2 - Kudzu (Pueraria montana var. lobata (syn. Pueraria lobata))"] = 60;
                this.ValueIndex["C2 - Mesquite 1 of 3 (Prosopis glandulosa)"] = 61;
                this.ValueIndex["C2 - Mesquite 2 of 3 (Prosopis pallida)"] = 62;
                this.ValueIndex["C2 - Mesquite 3 of 3 (Prosopis velutina)"] = 63;
                this.ValueIndex["C2 - Mother of millions 1 of 2 (Bryophyllum delagoense (syn. B. tubiflorum))"] = 64;
                this.ValueIndex["C2 - Mother of millions 2 of 2 (Kalanchoe delagoensis)"] = 65;
                this.ValueIndex["C2 - Mother of millions hybrid (Bryophyllum x houghtonii (syn. B.daigremontianum x B. delagoense, Kalanchoe x houghtonii))"] = 66;
                this.ValueIndex["C2 - Parkinsonia (Parkinsonia aculeata)"] = 67;
                this.ValueIndex["C2 - Parthenium (Parthenium hysterophorus)"] = 68;
                this.ValueIndex["C2 - Pond apple (Annona glabra)"] = 69;
                this.ValueIndex["C2 - Prickly acacia (Acacia nilotica)"] = 70;
                this.ValueIndex["C2 - Prickly pears: common pest pear or spiny pest pear (Opuntia stricta (syn. O. inermis))"] = 71;
                this.ValueIndex["C2 - Prickly pears: drooping tree pear (Opuntia monacantha (syn. O. vulgaris))"] = 72;
                this.ValueIndex["C2 - Prickly pears: spiny pest pear or common pest pear (Opuntia stricta (syn. O. inermis))"] = 73;
                this.ValueIndex["C2 - Prickly pears: tiger pear (Opuntia aurantiaca)"] = 74;
                this.ValueIndex["C2 - Prickly pears: velvety tree pear (Opuntia tomentosa)"] = 75;
                this.ValueIndex["C2 - Prickly pears: Westwood pear (Opuntia streptacantha)"] = 76;
                this.ValueIndex["C2 - Rat's tail grasses: American rat's tail grass (Sporobolus jacquemontii)"] = 77;
                this.ValueIndex["C2 - Rat's tail grasses: giant Parramatta grass (Sporobolus fertilis)"] = 78;
                this.ValueIndex["C2 - Rat's tail grasses: giant rat's tail grass 1 (Sporobolus pyramidalis)"] = 79;
                this.ValueIndex["C2 - Rat's tail grasses: giant rat's tail grass 2 (Sporobolus natalensis)"] = 80;
                this.ValueIndex["C2 - Rat's tail grasses: Parramatta grass (Sporobolus africanus)"] = 81;
                this.ValueIndex["C2 - Rubber vine (Cryptostegia grandiflora)"] = 82;
                this.ValueIndex["C2 - Salvinia (Salvinia molesta)"] = 83;
                this.ValueIndex["C2 - Sicklepods: foetid cassia (Senna tora)"] = 84;
                this.ValueIndex["C2 - Sicklepods: hairy cassia (Senna hirsuta)"] = 85;
                this.ValueIndex["C2 - Sicklepods: sicklepod (Senna obtusifolia)"] = 86;
                this.ValueIndex["C2 - Telegraph weed (Heterotheca grandiflora)"] = 87;
                this.ValueIndex["C2 - Thunbergia or blue thunbergia (Thunbergia grandiflora)"] = 88;
                this.ValueIndex["C2 - Tobacco weed (Elephantopus mollis)"] = 89;
                this.ValueIndex["C2 - Water hyacinth (Eichhornia crassipes)"] = 90;
                this.ValueIndex["C2 - Water lettuce (Pistia stratiotes)"] = 91;
                this.ValueIndex["C3 - African fountain grass (Pennisetum setaceum)"] = 92;
                this.ValueIndex["C3 - African tulip tree (Spathodea campanulata)"] = 93;
                this.ValueIndex["C3 - Asparagus fern: Ground asparagus (Asparagus aethiopicus Sprengeri)"] = 94;
                this.ValueIndex["C3 - Asparagus fern: Climbing asparagus (Asparagus africanus)"] = 95;
                this.ValueIndex["C3 - Asparagus fern: feathered asparagus fern (Asparagus plumosus)"] = 96;
                this.ValueIndex["C3 - Athel pine (Tamarix aphylla)"] = 97;
                this.ValueIndex["C3 - Balloon vine (Cardiospermum grandiflorum)"] = 98;
                this.ValueIndex["C3 - Blackberry 1 (Rubus anglocandicans)"] = 99;
                this.ValueIndex["C3 - Blackberry 2 (Rubus fruticosus agg.)"] = 100;
                this.ValueIndex["C3 - Broad-leaved pepper tree (Schinus terebinthifolius)"] = 101;
                this.ValueIndex["C3 - Camphor laurel (Cinnamomum camphora)"] = 102;
                this.ValueIndex["C3 - Captain Cook tree or yellow oleander (Cascabela thevetia (syn. Thevetia peruviana))"] = 103;
                this.ValueIndex["C3 - Cat's claw creeper (Macfadyena unguis-cati)"] = 104;
                this.ValueIndex["C3 - Chinese celtis (Celtis sinensis)"] = 105;
                this.ValueIndex["C3 - Dutchman's pipe or aristolochia (Aristolochia spp. other than native species)"] = 106;
                this.ValueIndex["C3 - Harungana (Harungana madagascariensis)"] = 107;
                this.ValueIndex["C3 - Kahili ginger (Hedychium gardnerianum)"] = 108;
                this.ValueIndex["C3 - Lantanas: common lantana or lantana (Lantana camara)"] = 109;
                this.ValueIndex["C3 - Lantanas: creeping lantana (Lantana montevidensis)"] = 110;
                this.ValueIndex["C3 - Madeira vine (Anredera cordifolia)"] = 111;
                this.ValueIndex["C3 - Ornamental rubber vine (Cryptostegia madagascariensis)"] = 112;
                this.ValueIndex["C3 - Privets: broad-leaf privet or tree privet (Ligustrum lucidum)"] = 113;
                this.ValueIndex["C3 - Privets: Chinese privet or small-leaf privet (Ligustrum sinense)"] = 114;
                this.ValueIndex["C3 - Privets: small-leaf privet or Chinese privet (Ligustrum sinense)"] = 115;
                this.ValueIndex["C3 - Singapore daisy (Sphagneticola trilobata (syn. Wedelia trilobata))"] = 116;
                this.ValueIndex["C3 - White ginger (Hedychium coronarium)"] = 117;
                this.ValueIndex["C3 - Willows: pencil willow (Salix humboldtiana (syn. S. chilensis))"] = 118;
                this.ValueIndex["C3 - Willows: tortured willow (Salix matsudana)"] = 119;
                this.ValueIndex["C3 - Yellow bells (Tecoma stans)"] = 120;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MDppSpeciesDomain = MDppSpeciesDomain;
    Object.defineProperty(MDppSpeciesDomain, "NoneObserved", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MDppSpeciesDomain, "C1AcaciasNonIndigenousToAustraliaAcaciellaSppMariosousaSppSenegaliaSppOtherThanSAlbizoidesAcaciaSppOtherThanANiloticaAndAFarnesiana", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MDppSpeciesDomain, "C1AlligatorWeedAlternantheraPhiloxeroides", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MDppSpeciesDomain, "C1AnchoredWaterHyacinthEichhorniaAzurea", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MDppSpeciesDomain, "C1BadharaBushGmelinaElliptica", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(MDppSpeciesDomain, "C1BitouBushChrysanthemoidesMoniliferaSubspRotundata", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(MDppSpeciesDomain, "C1BridalCreeperAsparagusAsparagoides", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 7
    });
    Object.defineProperty(MDppSpeciesDomain, "C1CandleberryMyrthMyricaFaya", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 8
    });
    Object.defineProperty(MDppSpeciesDomain, "C1ChileanNeedleGrassNassellaNeesiana", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 9
    });
    Object.defineProperty(MDppSpeciesDomain, "C1ChollaCactusCylindropuntiaSppAndHybridsOtherThanCFulgidaCImbricataAndCSpinosior", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(MDppSpeciesDomain, "C1ChristsThornZiziphusSpinaChristi", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 11
    });
    Object.defineProperty(MDppSpeciesDomain, "C1EurasianWaterMilfoilMyriophyllumSpicatum", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 12
    });
    Object.defineProperty(MDppSpeciesDomain, "C1FanwortCabombaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 13
    });
    Object.defineProperty(MDppSpeciesDomain, "C1FloatingWaterChestnutsTrapaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 14
    });
    Object.defineProperty(MDppSpeciesDomain, "C1GorseUlexEuropaeus", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 15
    });
    Object.defineProperty(MDppSpeciesDomain, "C1HarrisiaCactusHarrisiaSppSynEriocereusSppOtherThanHMartiniiHTortuosaAndHPomanensis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 16
    });
    Object.defineProperty(MDppSpeciesDomain, "C1HoneyLocustGleditsiaSppIncludingCultivarsAndVarieties", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 17
    });
    Object.defineProperty(MDppSpeciesDomain, "C1HorsetailsEquisetumSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 18
    });
    Object.defineProperty(MDppSpeciesDomain, "C1HygrophilaHygrophilaCostata", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 19
    });
    Object.defineProperty(MDppSpeciesDomain, "C1KostersCurseClidemiaHirta", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 20
    });
    Object.defineProperty(MDppSpeciesDomain, "C1LagarosiphonLagarosiphonMajor", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 21
    });
    Object.defineProperty(MDppSpeciesDomain, "C1LimnocharisOrYellowBurrheadLimnocharisFlava", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 22
    });
    Object.defineProperty(MDppSpeciesDomain, "C1MadrasThornPithecellobiumDulce", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 23
    });
    Object.defineProperty(MDppSpeciesDomain, "C1MexicanBeanTreeCecropiaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 24
    });
    Object.defineProperty(MDppSpeciesDomain, "C1MexicanFeatherGrassNassellaTenuissima", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 25
    });
    Object.defineProperty(MDppSpeciesDomain, "C1MiconiaMiconiaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 26
    });
    Object.defineProperty(MDppSpeciesDomain, "C1MikaniaVineMikaniaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 27
    });
    Object.defineProperty(MDppSpeciesDomain, "C1MimosaPigraMimosaPigra", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 28
    });
    Object.defineProperty(MDppSpeciesDomain, "C1PeruvianPrimroseBushLugwigiaPeruviana", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 29
    });
    Object.defineProperty(MDppSpeciesDomain, "C1PricklyPearOpuntiaSppOtherThanOFicusindicaOStrictaOAurantiacaOMonocanthaOTomentosaAndOStreptacantha", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 30
    });
    Object.defineProperty(MDppSpeciesDomain, "C1RedSesbaniaSesbaniaPunicea", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 31
    });
    Object.defineProperty(MDppSpeciesDomain, "C1SalviniasSalviniaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 32
    });
    Object.defineProperty(MDppSpeciesDomain, "C1SenegalTeaGymnocoronisSpilanthoides", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 33
    });
    Object.defineProperty(MDppSpeciesDomain, "C1SiamWeedChromolaenaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 34
    });
    Object.defineProperty(MDppSpeciesDomain, "C1SpikedPepperPiperAduncum", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 35
    });
    Object.defineProperty(MDppSpeciesDomain, "C1ThunbergiasAnnualThunbergiaThunbergiaAnnua", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 36
    });
    Object.defineProperty(MDppSpeciesDomain, "C1ThunbergiasFragrantThunbergiaThunbergiaFragrans", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 37
    });
    Object.defineProperty(MDppSpeciesDomain, "C1ThunbergiasLauralClockvineThunbergiaLaurifolia", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 38
    });
    Object.defineProperty(MDppSpeciesDomain, "C1WaterMimosa1Of2NeptuniaOleracea", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 39
    });
    Object.defineProperty(MDppSpeciesDomain, "C1WaterMimosa1Of2NeptuniaPlena", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 40
    });
    Object.defineProperty(MDppSpeciesDomain, "C1WaterSoldiersStratiotesAloides", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 41
    });
    Object.defineProperty(MDppSpeciesDomain, "C1WillowSalixSppOtherThanSBabylonicaSHumboldtianaSMatsudanaSXCalodendronAndSXReichardtii", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 42
    });
    Object.defineProperty(MDppSpeciesDomain, "C1WitchWeedsStrigaSppOtherThanNativeSpecies", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 43
    });
    Object.defineProperty(MDppSpeciesDomain, "C1YellowGingerHedychiumFlavescens", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 44
    });
    Object.defineProperty(MDppSpeciesDomain, "C2AfricanBoxthornLyciumFerocissimum", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 45
    });
    Object.defineProperty(MDppSpeciesDomain, "C2AnnualRagweedAmbrosiaArtemisiifolia", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 46
    });
    Object.defineProperty(MDppSpeciesDomain, "C2BellyAcheBushJatrophaGossypiifoliaAndHybrids", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 47
    });
    Object.defineProperty(MDppSpeciesDomain, "C2CabombaCabombaCaroliniana", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 48
    });
    Object.defineProperty(MDppSpeciesDomain, "C2ChineseAppleZiziphusMauritiana", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 49
    });
    Object.defineProperty(MDppSpeciesDomain, "C2ChollaCactiCoralCactusCylindropuntiaFulgida", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 50
    });
    Object.defineProperty(MDppSpeciesDomain, "C2ChollaCactiDevilsRopePearCylindropuntiaImbricata", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 51
    });
    Object.defineProperty(MDppSpeciesDomain, "C2ChollaCactiSnakeCactusCylindropuntiaSpinosior", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 52
    });
    Object.defineProperty(MDppSpeciesDomain, "C2FireweedSenecioMadagascariensis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 53
    });
    Object.defineProperty(MDppSpeciesDomain, "C2GambaGrassAndropogonGayanus", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 54
    });
    Object.defineProperty(MDppSpeciesDomain, "C2GiantSensitivePlantMimosaDiplotrichaVarDiplotricha", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 55
    });
    Object.defineProperty(MDppSpeciesDomain, "C2GroundselBushBaccharisHalimifolia", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 56
    });
    Object.defineProperty(MDppSpeciesDomain, "C2HarrisiaCactus1Of3HarrisiaMartiniiSynEriocereusMartinii", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 57
    });
    Object.defineProperty(MDppSpeciesDomain, "C2HarrisiaCactus2Of3HarrisiaTortuosa", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 58
    });
    Object.defineProperty(MDppSpeciesDomain, "C2HarrisiaCactus3Of3HarrisiaPomanensisSynCereusPomanensis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 59
    });
    Object.defineProperty(MDppSpeciesDomain, "C2HymenachneOrOliveHymenachneHymenachneAmplexicaulis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 60
    });
    Object.defineProperty(MDppSpeciesDomain, "C2KudzuPuerariaMontanaVarLobataSynPuerariaLobata", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 61
    });
    Object.defineProperty(MDppSpeciesDomain, "C2Mesquite1Of3ProsopisGlandulosa", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 62
    });
    Object.defineProperty(MDppSpeciesDomain, "C2Mesquite2Of3ProsopisPallida", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 63
    });
    Object.defineProperty(MDppSpeciesDomain, "C2Mesquite3Of3ProsopisVelutina", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 64
    });
    Object.defineProperty(MDppSpeciesDomain, "C2MotherOfMillions1Of2BryophyllumDelagoenseSynBTubiflorum", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 65
    });
    Object.defineProperty(MDppSpeciesDomain, "C2MotherOfMillions2Of2KalanchoeDelagoensis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 66
    });
    Object.defineProperty(MDppSpeciesDomain, "C2MotherOfMillionsHybridBryophyllumXHoughtoniiSynBDaigremontianumXBDelagoenseKalanchoeXHoughtonii", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 67
    });
    Object.defineProperty(MDppSpeciesDomain, "C2ParkinsoniaParkinsoniaAculeata", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 68
    });
    Object.defineProperty(MDppSpeciesDomain, "C2PartheniumPartheniumHysterophorus", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 69
    });
    Object.defineProperty(MDppSpeciesDomain, "C2PondAppleAnnonaGlabra", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 70
    });
    Object.defineProperty(MDppSpeciesDomain, "C2PricklyAcaciaAcaciaNilotica", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 71
    });
    Object.defineProperty(MDppSpeciesDomain, "C2PricklyPearsCommonPestPearOrSpinyPestPearOpuntiaStrictaSynOInermis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 72
    });
    Object.defineProperty(MDppSpeciesDomain, "C2PricklyPearsDroopingTreePearOpuntiaMonacanthaSynOVulgaris", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 73
    });
    Object.defineProperty(MDppSpeciesDomain, "C2PricklyPearsSpinyPestPearOrCommonPestPearOpuntiaStrictaSynOInermis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 74
    });
    Object.defineProperty(MDppSpeciesDomain, "C2PricklyPearsTigerPearOpuntiaAurantiaca", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 75
    });
    Object.defineProperty(MDppSpeciesDomain, "C2PricklyPearsVelvetyTreePearOpuntiaTomentosa", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 76
    });
    Object.defineProperty(MDppSpeciesDomain, "C2PricklyPearsWestwoodPearOpuntiaStreptacantha", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 77
    });
    Object.defineProperty(MDppSpeciesDomain, "C2RatsTailGrassesAmericanRatsTailGrassSporobolusJacquemontii", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 78
    });
    Object.defineProperty(MDppSpeciesDomain, "C2RatsTailGrassesGiantParramattaGrassSporobolusFertilis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 79
    });
    Object.defineProperty(MDppSpeciesDomain, "C2RatsTailGrassesGiantRatsTailGrass1SporobolusPyramidalis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 80
    });
    Object.defineProperty(MDppSpeciesDomain, "C2RatsTailGrassesGiantRatsTailGrass2SporobolusNatalensis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 81
    });
    Object.defineProperty(MDppSpeciesDomain, "C2RatsTailGrassesParramattaGrassSporobolusAfricanus", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 82
    });
    Object.defineProperty(MDppSpeciesDomain, "C2RubberVineCryptostegiaGrandiflora", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 83
    });
    Object.defineProperty(MDppSpeciesDomain, "C2SalviniaSalviniaMolesta", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 84
    });
    Object.defineProperty(MDppSpeciesDomain, "C2SicklepodsFoetidCassiaSennaTora", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 85
    });
    Object.defineProperty(MDppSpeciesDomain, "C2SicklepodsHairyCassiaSennaHirsuta", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 86
    });
    Object.defineProperty(MDppSpeciesDomain, "C2SicklepodsSicklepodSennaObtusifolia", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 87
    });
    Object.defineProperty(MDppSpeciesDomain, "C2TelegraphWeedHeterothecaGrandiflora", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 88
    });
    Object.defineProperty(MDppSpeciesDomain, "C2ThunbergiaOrBlueThunbergiaThunbergiaGrandiflora", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 89
    });
    Object.defineProperty(MDppSpeciesDomain, "C2TobaccoWeedElephantopusMollis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 90
    });
    Object.defineProperty(MDppSpeciesDomain, "C2WaterHyacinthEichhorniaCrassipes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 91
    });
    Object.defineProperty(MDppSpeciesDomain, "C2WaterLettucePistiaStratiotes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 92
    });
    Object.defineProperty(MDppSpeciesDomain, "C3AfricanFountainGrassPennisetumSetaceum", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 93
    });
    Object.defineProperty(MDppSpeciesDomain, "C3AfricanTulipTreeSpathodeaCampanulata", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 94
    });
    Object.defineProperty(MDppSpeciesDomain, "C3AsparagusFernGroundAsparagusAsparagusAethiopicusSprengeri", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 95
    });
    Object.defineProperty(MDppSpeciesDomain, "C3AsparagusFernClimbingAsparagusAsparagusAfricanus", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 96
    });
    Object.defineProperty(MDppSpeciesDomain, "C3AsparagusFernFeatheredAsparagusFernAsparagusPlumosus", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 97
    });
    Object.defineProperty(MDppSpeciesDomain, "C3AthelPineTamarixAphylla", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 98
    });
    Object.defineProperty(MDppSpeciesDomain, "C3BalloonVineCardiospermumGrandiflorum", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 99
    });
    Object.defineProperty(MDppSpeciesDomain, "C3Blackberry1RubusAnglocandicans", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(MDppSpeciesDomain, "C3Blackberry2RubusFruticosusAgg", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 101
    });
    Object.defineProperty(MDppSpeciesDomain, "C3BroadLeavedPepperTreeSchinusTerebinthifolius", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 102
    });
    Object.defineProperty(MDppSpeciesDomain, "C3CamphorLaurelCinnamomumCamphora", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 103
    });
    Object.defineProperty(MDppSpeciesDomain, "C3CaptainCookTreeOrYellowOleanderCascabelaThevetiaSynThevetiaPeruviana", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 104
    });
    Object.defineProperty(MDppSpeciesDomain, "C3CatsClawCreeperMacfadyenaUnguisCati", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 105
    });
    Object.defineProperty(MDppSpeciesDomain, "C3ChineseCeltisCeltisSinensis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 106
    });
    Object.defineProperty(MDppSpeciesDomain, "C3DutchmansPipeOrAristolochiaAristolochiaSppOtherThanNativeSpecies", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 107
    });
    Object.defineProperty(MDppSpeciesDomain, "C3HarunganaHarunganaMadagascariensis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 108
    });
    Object.defineProperty(MDppSpeciesDomain, "C3KahiliGingerHedychiumGardnerianum", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 109
    });
    Object.defineProperty(MDppSpeciesDomain, "C3LantanasCommonLantanaOrLantanaLantanaCamara", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 110
    });
    Object.defineProperty(MDppSpeciesDomain, "C3LantanasCreepingLantanaLantanaMontevidensis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 111
    });
    Object.defineProperty(MDppSpeciesDomain, "C3MadeiraVineAnrederaCordifolia", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 112
    });
    Object.defineProperty(MDppSpeciesDomain, "C3OrnamentalRubberVineCryptostegiaMadagascariensis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 113
    });
    Object.defineProperty(MDppSpeciesDomain, "C3PrivetsBroadLeafPrivetOrTreePrivetLigustrumLucidum", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 114
    });
    Object.defineProperty(MDppSpeciesDomain, "C3PrivetsChinesePrivetOrSmallLeafPrivetLigustrumSinense", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 115
    });
    Object.defineProperty(MDppSpeciesDomain, "C3PrivetsSmallLeafPrivetOrChinesePrivetLigustrumSinense", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 116
    });
    Object.defineProperty(MDppSpeciesDomain, "C3SingaporeDaisySphagneticolaTrilobataSynWedeliaTrilobata", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 117
    });
    Object.defineProperty(MDppSpeciesDomain, "C3WhiteGingerHedychiumCoronarium", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 118
    });
    Object.defineProperty(MDppSpeciesDomain, "C3WillowsPencilWillowSalixHumboldtianaSynSChilensis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 119
    });
    Object.defineProperty(MDppSpeciesDomain, "C3WillowsTorturedWillowSalixMatsudana", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 120
    });
    Object.defineProperty(MDppSpeciesDomain, "C3YellowBellsTecomaStans", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 121
    });
    Object.defineProperty(MDppSpeciesDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
